import { Spin } from 'antd';
import { Text } from 'components/mvp-typography';
import { InternationalNumberFormatter } from '../formatNumber';

interface UnitPriceRendererProps {
  unitPrice: number;
  isLoading: boolean;
}

/**
 * Component that renders the unit price display with loading state.
 */
export function UnitPriceRenderer({
  unitPrice,
  isLoading
}: UnitPriceRendererProps): React.ReactElement {
  if (isLoading) {
    return (
      <Text>
        <Spin
          size="small"
          tip="Loading..."
          style={{ display: 'inline-block' }}
        />
      </Text>
    );
  }

  return <Text strong>${InternationalNumberFormatter.format(unitPrice)}</Text>;
}
